var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"outline-btn",attrs:{"to":_vm.url}},[_c('i',{staticClass:"fas fa-plus mr-2"}),_vm._v("Add ")])
}
var staticRenderFns = []

export { render, staticRenderFns }